export enum RateGroupSettlementAction {
    ChargeCreditCard = 'ChargeCreditCard',
    CreatePreauthorization = 'CreatePreauthorization',
}
